import { RoutingNode } from 'hooks/useRouteCalculator/routing-graph';

const packagePageRouting: RoutingNode = {
    forwardEdges: [],
    backwardEdges: [],
    forAllForwardEdges: state => !!state.selectedPackage,
};

export default packagePageRouting;
